export const RecommendSettingPage = () => {
  return (
    <>
      <div>推しメン設定</div>
    </>
  )
}
